import './ManageTravelers.scss';
import React, { useState, useEffect } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import BlankImg from '../../../assets/images/no-picture-available.jpg';

import {
    addManageTravelService,
    getManageTravelService,
    editTravellerService,
    deleteTravellerService,
    activeDeactiveTravelService
} from '../../../services/AdminService';
import { imageUrlTravellers } from '../../../services/CommonUrl';
import { useAuth } from '../../../contexts/AuthProvider';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { TravelerListPlaceholder } from '../../../components/skeleton-placeholder';
import { NoDataFound } from '../../../components/no-data-found';
import TravelerModal from './TravelerModal';
import { DeleteModal } from '../../../components/delete-modal';

const ManageTravelers = () => {
    const { authed } = useAuth();
    const [isLoadingTraveler, setIsLoadingTraveler] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [mode, setMode] = useState("add");
    const [selectedTravelerData, setSelectedTravelerData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [getManageTravellers, setGetManageTravellers] = useState([]);

    const handleOpenModal = (mode, travelerData) => {
        if(travelerData){
            setSelectedTravelerData(travelerData);
            formik.setFieldValue("passport_front_image", selectedTravelerData?.passport_front_image);
            formik.setFieldValue("passport_back_image", selectedTravelerData?.passport_back_image);
            formik.setFieldValue("socialId_front_image", selectedTravelerData?.socialId_front_image);
            formik.setFieldValue("socialId_back_image", selectedTravelerData?.socialId_back_image);
        }else{
            formik.resetForm();
        }
        setShowModal(true);
        setMode(mode);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedTravelerData(null);
        formik.resetForm();
    };

    const formik = useFormik({
        initialValues: {
            title: selectedTravelerData?.title || "",
            first_name: selectedTravelerData?.first_name || "",
            last_name: selectedTravelerData?.last_name || "",
            gender: selectedTravelerData?.gender || "",
            dob: selectedTravelerData?.dob || "",
            passport_no: selectedTravelerData?.passport_no || "",
            socialId_no: selectedTravelerData?.socialId_no || "",
            passport_front_image: selectedTravelerData?.passport_front_image || "",
            passport_back_image: selectedTravelerData?.passport_back_image || "",
            socialId_front_image: selectedTravelerData?.socialId_front_image || "",
            socialId_back_image: selectedTravelerData?.socialId_back_image || ""
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            title: Yup.string()
                .required('Please select title.'),
            first_name: Yup.string()
                .required('Please enter first name.'),
            last_name: Yup.string()
                .required('Please enter last name.'),
            gender: Yup.string()
                .required('Please select gender.'),
            dob: Yup.date()
                .nullable()
                .transform((curr, orig) => orig === '' ? null : curr)
                .required('Please enter date of birth.'),
            // passport_no: Yup.string()
            // .required('Please enter passport No.'),
            // socialId_no: Yup.string()
            // .required('Please enter social No.'),
        }),
        onSubmit: values => {
            // console.log('Add value:', values);
            setIsLoading(true);
            const formData = new FormData();
            if (mode === "add") {
                formData.append("userId", authed?.user?._id)
            } else {
                formData.append("_id", selectedTravelerData?._id)
            }

            Object.entries(values).forEach(([key, value]) => {
                formData.append(key, value);
            });

            if (mode === "add") {
                addManageTravelService(formData, async (res) => {
                    if (res.status === 200) {
                        //console.log("API 1 response: ", res.data.data);
                        getTravellerList();
                        handleCloseModal();
                    } else {
                        console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                    }
                    setIsLoading(false);
                });
            } else {
                editTravellerService(formData, async (res) => {
                    if (res.status === 200) {
                        // console.log("API editTravellerService response: ", res.data);
                        getTravellerList();
                        handleCloseModal();
                    } else {
                        console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
                    }
                    setIsLoading(false);
                });
            }

        }
    });

    const getTravellerList = async () => {
        setIsLoadingTraveler(true);
        await getManageTravelService({ userId: authed?.user?._id }, async (res) => {
            setIsLoadingTraveler(false);
            if (res.status === 200) {
                //   console.log("API Get traveller response: ", res.data.data);
                await setGetManageTravellers(res.data.data);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    }

    const handleDeleteTraveler = (data) => {
        setShowDeleteModal(true);
        setSelectedTravelerData(data);
    }

    const deleteTraveler = async () => {
        setIsLoading(true);
        await deleteTravellerService({ _id: selectedTravelerData?._id }, async (res) => {
            if (res.status === 200) {
                //   console.log("API Get traveller response: ", res.data.data);
                setGetManageTravellers((items) => items.filter((item) => item._id !== selectedTravelerData?._id))
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
            setShowDeleteModal(false);
            setIsLoading(false);
        });
    }

    const changeTravelerStatus = async (data) => {
        const obj = {
            _id: data._id,
            isActive: data.isActive ? false : true,
        };

        await activeDeactiveTravelService(obj, async (res) => {
            if (res.status === 200) {
                // console.log("Status updated successfully. ");
                const updatedItem = getManageTravellers.map(item =>
                    item._id === data._id ? { ...item, isActive: obj.isActive } : item
                );
                setGetManageTravellers(updatedItem);
            } else {
                console.log(`Error: ${res.data?.message || "An unexpected error occurred."}`);
            }
        });
    };

    useEffect(() => {
        getTravellerList();
    }, []);

    // console.log(formik.values)

    return (
        <>
            <div className="content-body">
                <div className="mt-header-block mb-3">
                    <h1 className="d-col-title">Manage Travelers</h1>
                    <button type="button" className="btn btn-primary-color" onClick={() => handleOpenModal("add")}><i className="bi bi-plus-lg"></i> Add</button>
                </div>

                {isLoadingTraveler ? (
                    <div className="mt-table-wrap table-responsive">
                        <TravelerListPlaceholder number={8} />
                    </div>
                ) : (
                    getManageTravellers.length > 0 ?
                        <div className="mt-table-wrap table-responsive">
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Gender</th>
                                        <th scope="col">DOB</th>
                                        <th scope="col">Passport No.</th>
                                        <th scope="col">Social Id No.</th>
                                        <th scope="col" className="text-right">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {getManageTravellers.map((travellersItem, i) => {
                                        return (
                                            <>
                                                <tr key={travellersItem._id}>
                                                    <td className='col-3'>{travellersItem.first_name} {travellersItem.last_name}</td>
                                                    <td className='col-2'>{travellersItem.gender}</td>
                                                    <td className='col-2 text-nowrap'>{moment(travellersItem.dob).format("DD-MM-YYYY")}</td>
                                                    <td className='col-2'>
                                                        <b>{travellersItem.passport_no ? travellersItem.passport_no : "N/A"}</b>
                                                        <div className="passport-img-row">
                                                            <span><img src={travellersItem.passport_front_image ? imageUrlTravellers + travellersItem.passport_front_image : BlankImg} alt="Image" /></span>
                                                            <span><img src={travellersItem.passport_back_image ? imageUrlTravellers + travellersItem.passport_back_image : BlankImg} alt="Image" /></span>
                                                        </div>
                                                    </td>
                                                    <td className='col-2'>
                                                        <b>{travellersItem.socialId_no ? travellersItem.socialId_no : "N/A"}</b>
                                                        <div className="passport-img-row">
                                                            <span><img src={travellersItem.socialId_front_image ? imageUrlTravellers + travellersItem.socialId_front_image : BlankImg} alt="Image" /></span>
                                                            <span><img src={travellersItem.socialId_back_image ? imageUrlTravellers + travellersItem.socialId_back_image : BlankImg} alt="Image" /></span>
                                                        </div>
                                                    </td>
                                                    <td className="mt-btn-groups col-1">
                                                        <OverlayTrigger
                                                            placement="bottom"
                                                            trigger="focus"
                                                            overlay={
                                                                <Popover>
                                                                    <Popover.Body className="btn-mt-actions">
                                                                        <button onClick={() => changeTravelerStatus(travellersItem)} type="button" className="btn">
                                                                            {travellersItem.isActive ? <><i className="bi bi-toggle-off"></i> Deactivate</> : <><i className="bi bi-toggle-on"></i> Active</>}
                                                                        </button>
                                                                        <button onClick={() => handleOpenModal("edit", travellersItem)} type="button" className="btn"><i className="bi bi-pencil"></i> Edit</button>
                                                                        <button onClick={() => handleOpenModal("view", travellersItem)} type="button" className="btn"><i className="bi bi-eye"></i> View</button>
                                                                        <button onClick={() => handleDeleteTraveler(travellersItem)} type="button" className="btn"><i className="bi bi-trash"></i> Delete</button>
                                                                    </Popover.Body>
                                                                </Popover>
                                                            }
                                                        >
                                                            <button className="btn"><i className="bi bi-three-dots-vertical"></i></button>
                                                        </OverlayTrigger>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        :
                        <NoDataFound />
                )}
            </div>

            {showModal && (
                <TravelerModal
                    show={showModal}
                    onClose={handleCloseModal}
                    onSubmit={formik.handleSubmit}
                    formik={formik}
                    mode={mode}
                    isLoading={isLoading}
                    blankImg={BlankImg}
                    travelerData={selectedTravelerData}
                />
            )}

            {showDeleteModal && (
                <DeleteModal
                    message={"Are you sure you want to delete"}
                    showDeleteModal={showDeleteModal}
                    setShowDeleteModal={setShowDeleteModal}
                    confirmFnc={() => deleteTraveler()}
                    isLoading={isLoading}
                />
            )}
        </>
    );
}

export default ManageTravelers;